import { NavLink, useLocation } from "react-router";
import styled from "styled-components";

const Styled = styled.nav`
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    gap: 24px;
    position: absolute;
    right: max(64px, 8vw);
    top: 32px;
`;

const StyledLink = styled(NavLink)`
    color: transparent;
    font-family: var(--font-mono);
    font-weight: bold;
    font-size: 1.2rem;
    text-decoration: none;
    text-transform: uppercase;
    -webkit-text-stroke: 1px #fff9;

    &.active {
        -webkit-text-stroke: .5px #fffb;
        color: #fffb;
    }

    &[href="${ ({ pathname }) => pathname }"] {
        color: #fff;
    }

    &:hover {
        color: #fff;
    }
`;

export default function Navigation() {
    const location = useLocation();

    return (
        <Styled>
            <StyledLink pathname={ location.pathname } to="./RevitParameterTemplates">parameters</StyledLink>
            <StyledLink pathname={ location.pathname } to="./RevitValues">values</StyledLink>
        </Styled>
    );
}
